'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import emptyFunction from 'react-utils/emptyFunction';
import { connect } from 'react-redux';
import text from 'I18n/utils/unescapedText';
import * as CustomWidgetFieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { ALLOWED_STYLE_FIELDS_GROUPED } from 'DesignData/constants/StyleFields';
import CustomWidgetFieldTypeCategories from 'DesignData/enums/CustomWidgetFieldTypeCategories';
import { CREATE } from 'DesignData/enums/CustomWidgetFieldTypePermissions';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { makeGetCustomWidgetBuffer } from 'DesignData/selectors/customWidgetBuffers';
import { makeGetFieldTypePermissions } from 'DesignData/selectors/customWidgetEditorOptions';
import UITypeahead from 'UIComponents/typeahead/UITypeahead';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.main.fields.fieldsDropdown.${key}`;

const GROUPED_FIELD_TYPES = {
  [CustomWidgetFieldTypeCategories.CONTENT]: [CustomWidgetFieldTypes.DATE, CustomWidgetFieldTypes.DATE_TIME, CustomWidgetFieldTypes.EMBED, CustomWidgetFieldTypes.LINK, CustomWidgetFieldTypes.NUMBER, CustomWidgetFieldTypes.RICH_TEXT, CustomWidgetFieldTypes.TEXT, CustomWidgetFieldTypes.HTML, CustomWidgetFieldTypes.HUBL, CustomWidgetFieldTypes.SIMPLE_MENU, CustomWidgetFieldTypes.URL],
  [CustomWidgetFieldTypeCategories.LOGIC]: [CustomWidgetFieldTypes.BOOLEAN, CustomWidgetFieldTypes.CHOICE],
  [CustomWidgetFieldTypeCategories.SELECTORS]: [CustomWidgetFieldTypes.BLOG, CustomWidgetFieldTypes.COLOR, CustomWidgetFieldTypes.CRM_OBJECT, CustomWidgetFieldTypes.CRM_OBJECT_PROPERTY, CustomWidgetFieldTypes.CTA, CustomWidgetFieldTypes.EMAIL, CustomWidgetFieldTypes.FILE, CustomWidgetFieldTypes.FOLLOW_UP_EMAIL, CustomWidgetFieldTypes.FONT, CustomWidgetFieldTypes.FORM, CustomWidgetFieldTypes.HUBDB_ROW, CustomWidgetFieldTypes.HUBDB_TABLE, CustomWidgetFieldTypes.ICON, CustomWidgetFieldTypes.IMAGE, CustomWidgetFieldTypes.LOGO, CustomWidgetFieldTypes.MEETING, CustomWidgetFieldTypes.MENU, CustomWidgetFieldTypes.PAGE, CustomWidgetFieldTypes.PAYMENT, CustomWidgetFieldTypes.SFDC_CAMPAIGN, CustomWidgetFieldTypes.SURVEY, CustomWidgetFieldTypes.TAG, CustomWidgetFieldTypes.VIDEO, CustomWidgetFieldTypes.WORKFLOW]
};
const V1_FIELD_TYPES = [CustomWidgetFieldTypes.TEXT, CustomWidgetFieldTypes.RICH_TEXT, CustomWidgetFieldTypes.IMAGE, CustomWidgetFieldTypes.CHOICE, CustomWidgetFieldTypes.BOOLEAN];

function makeMapStateToProps() {
  const getFieldTypePermissions = makeGetFieldTypePermissions();
  const getCustomWidgetBuffer = makeGetCustomWidgetBuffer();
  return function mapStateToProps(state, props) {
    const {
      schemaVersion
    } = getCustomWidgetBuffer(state, props) || {};
    return {
      isV1: schemaVersion === 1,
      fieldTypePermissions: getFieldTypePermissions(state, props)
    };
  };
}

class CreateFieldList extends Component {
  constructor(...args) {
    super(...args);

    this.onFieldCreate = e => {
      this.props.onFieldCreate(e.target.value);
    };
  }

  getFieldTypeOptions(fieldTypeCategory) {
    const fieldTypeOptions = GROUPED_FIELD_TYPES[fieldTypeCategory].reduce((options, fieldType) => {
      if (this.props.fieldTypePermissions[fieldType][CREATE]) {
        const fieldTypeLabel = CustomWidgetField.getFieldTypeLabel(fieldType);
        options.push({
          text: fieldTypeLabel,
          value: fieldType
        });
      }

      return options;
    }, []);
    fieldTypeOptions.sort((a, b) => {
      return a.text.localeCompare(b.text);
    });
    return fieldTypeOptions;
  }

  render() {
    if (this.props.isV1) {
      const fieldOptions = V1_FIELD_TYPES.map(fieldType => {
        return {
          text: CustomWidgetField.getFieldTypeLabel(fieldType),
          value: fieldType
        };
      });
      return /*#__PURE__*/_jsx(UITypeahead, {
        onChange: this.onFieldCreate,
        options: fieldOptions
      });
    }

    if (this.props.isStyleTab) {
      const fieldOptions = ALLOWED_STYLE_FIELDS_GROUPED.map(fieldType => {
        return {
          text: CustomWidgetField.getFieldTypeLabel(fieldType),
          value: fieldType
        };
      });
      return /*#__PURE__*/_jsx(UITypeahead, {
        onChange: this.onFieldCreate,
        options: fieldOptions
      });
    }

    const fieldOptions = Object.keys(GROUPED_FIELD_TYPES).map(fieldTypeCategory => {
      return {
        text: text(i18nKey(`fieldCategoryLabels.${fieldTypeCategory}`)),
        value: fieldTypeCategory,
        options: this.getFieldTypeOptions(fieldTypeCategory)
      };
    });
    return /*#__PURE__*/_jsx(UITypeahead, {
      onChange: this.onFieldCreate,
      options: fieldOptions
    });
  }

}

CreateFieldList.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  onFieldCreate: PropTypes.func,
  fieldTypePermissions: PropTypes.object.isRequired,
  isV1: PropTypes.bool.isRequired,
  isStyleTab: PropTypes.bool
};
CreateFieldList.defaultProps = {
  onFieldCreate: emptyFunction
};
export default connect(makeMapStateToProps)(CreateFieldList);